import styles from './knowledgeFormPage.module.less'
import { FormItem, FormRow } from '../ProjectCreatePage/components/StepOne/StepOne';
import AInput from '@/components/A/AInput/AInput';
import AButton from '@/components/A/AButton/AButton';
import AIcon from '@/components/A/AIcon/AIcon';
import { useEffect, useState } from 'react';
import { commonUtils } from '@/helpers/commonUtils';
import DropdownSelector from '@/components/ApplyTrialBox/components/DropdownSelector/DropdownSelector';
import { useTranslation } from 'react-i18next';
import useTrialOptions from '@/helpers/commonHooks/useTrialOptions';
import { INTERNAL_HOST } from '@/commonConst';
import ASelect from '@/components/A/ASelect/ASelect';
import useProvinceOptions from '@/helpers/commonHooks/useProvinceOptions';
import { api } from '@/api';
import { useSearchParams } from 'react-router-dom';
import { message } from 'antd';
import TRANSLATION from '@/i18n/locales/zh/translation';
import { useTypedLocalStorage } from '@/helpers/commonHooks/useTypedLocalStorage';
import { useRequest } from 'alova/client';



interface Opt {
  label: string
  value: string
}

function KnowledgeFormPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const blogId = searchParams.get('blogId')
  const [submitted, setSubmitted] = useTypedLocalStorage('knowledge-form-submit', { defaultValue: false })
  const isInternal = INTERNAL_HOST.includes(location.hostname)
  const { DEPARTMENT_OPTIONS, DepartmentEnum, ROLE_OPTIONS, RoleEnum, COUNTRY_OPTIONS, CountryEnum } = useTrialOptions()
  const { PROVINCE_OPTIONS } = useProvinceOptions()
  const [name, setName] = useState<string | undefined>(undefined)
  const [companyName, setCompanyName] = useState<string | undefined>(undefined)
  const [email, setEmail] = useState<string | undefined>(undefined)
  const [department, setDepartment] = useState<Opt | undefined>(undefined)
  const [role, setRole] = useState<Opt | undefined>(undefined)
  const [country, setCountry] = useState<Opt | undefined>(undefined)
  const [province, setProvince] = useState<string | undefined>(undefined)
  const [mode, setMode] = useState<'form' | 'download'>()
  const [formError, setFromError] = useState([
    { key: 'name', error: false, msg: '' },
    { key: 'email', error: false, msg: '' },
    { key: 'companyName', error: false, msg: '' },
    { key: 'department', error: false, msg: '' },
    { key: 'role', error: false, msg: '' },
    { key: 'country', error: false, msg: '' },
    { key: 'province', error: false, msg: '' },
  ])
  const { data } = useRequest(api.knowledge.detail({ uid: blogId || '' }), {
    immediate: true,
  })

  const [resource, setResource] = useState<Array<{ title: string, url: string }>>([])

  const validate = (force: boolean = false) => {
    const validateError = formError
    const nameError = (force: boolean) => {
      const error = force ? !name : name === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const companyNameError = (force: boolean) => {
      const error = force ? !companyName : companyName === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const emailError = (force: boolean) => {
      const error = force ? !email : email === ''
      // 校验邮箱格式
      if (!error && email) {
        if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email)) {
          return { error: true, msg: t('modals.freeTrialModal.applyBox.pleaseEnterValidEmail') }
        }
      }
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const departmentError = (force: boolean) => {
      const error = force ? (!department || department?.label === '') : department?.label === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const roleError = (force: boolean) => {
      const error = force ? (!role || role?.label === '') : role?.label === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const countryError = (force: boolean) => {
      const error = force ? (!country || country?.label === '') : country?.label === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const provinceError = (force: boolean) => {
      const error = force ? (!province || province === '') : province === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const index1 = validateError.findIndex(e => e.key === 'name')
    validateError[index1].error = nameError(force).error
    validateError[index1].msg = nameError(force).msg
    const index2 = validateError.findIndex(e => e.key === 'email')
    validateError[index2].error = emailError(force).error
    validateError[index2].msg = emailError(force).msg
    const index3 = validateError.findIndex(e => e.key === 'department')
    validateError[index3].error = departmentError(force).error
    validateError[index3].msg = departmentError(force).msg
    const index4 = validateError.findIndex(e => e.key === 'role')
    validateError[index4].error = roleError(force).error
    validateError[index4].msg = roleError(force).msg
    if (isInternal) {
      const index5 = validateError.findIndex(e => e.key === 'province')
      validateError[index5].error = provinceError(force).error
      validateError[index5].msg = provinceError(force).msg
    } else {
      const index5 = validateError.findIndex(e => e.key === 'country')
      validateError[index5].error = countryError(force).error
      validateError[index5].msg = countryError(force).msg
    }
    const index6 = validateError.findIndex(e => e.key === 'companyName')
    validateError[index6].error = companyNameError(force).error
    validateError[index6].msg = companyNameError(force).msg
    // const index6 = validateError.findIndex(e => e.key === 'city')
    // validateError[index6].error = country?.value === CountryEnum.China ? cityError(force).error : false
    // validateError[index6].msg = country?.value === CountryEnum.China ? cityError(force).msg : ''
    return [...validateError]
  }

  const handleSubmit = async () => {
    const validateError = validate(true)
    setFromError(validateError)
    const allPass = validateError.every(e => !e.error)
    try {
      if (allPass) {
        let location = ''
        if (isInternal) {
          location = province!
        } else {
          const countryKeyIsOther = country!.value === CountryEnum.Other
          const _country = countryKeyIsOther ? country!.label : commonUtils.transferCountryKeyToZhTranslateText(country!.value)
          location = _country
        }
        const roleKeyIsOther = role!.value === RoleEnum.Other
        const _position = roleKeyIsOther ? role!.label : (TRANSLATION as any).modals.freeTrialModal.role[role?.value || '']
        const departmentIsOther = department!.value === DepartmentEnum.Other
        const _department = departmentIsOther ? department!.label : (TRANSLATION as any).modals.freeTrialModal.department[department?.value || '']
        await api.knowledge.submitForm({
          customerName: name || '',
          companyName: companyName || '',
          department: _department,
          position: _position,
          email: email || '',
          location: location || '',
          blogUid: blogId || ''
        })
        message.success(t('knowledgeFormPage.submitSuccess'))
        setSubmitted(true)
      }
    } catch (error) {
      console.error(error)
      //
    }
  }

  const handleDownload = (p: { url: string, title: string }) => {
    commonUtils.downloadFile(p.url, p.title)
    message.success(t('knowledgeFormPage.downloadSuccess'))
  }

  useEffect(() => {
    if (submitted) {
      setMode('download')
    } else {
      setMode('form')
    }
  }, [submitted])


  useEffect(() => {
    if (data) {
      setResource(data.data.blogResourceIds.map(item => ({
        title: item.fileName,
        url: item.fileUrl,
      })))
    }
  }, [data])


  return (
    <div className={styles.knowledgeFormPage} data-testid='knowledge-form-page'>
      <div className={styles.knowledgeFormPageContent}>
        <div className={styles.card}>
          <div className={styles.cardInner}>
            {
              mode === 'form' && <>
                <p className={styles.title}>{t('knowledgeFormPage.title1')}</p>
                <div className={styles.formBox}>
                  <FormRow style={{ marginTop: 0 }}>
                    <FormItem label={t('knowledgeFormPage.name')} required
                      error={formError.find(e => e.key === 'name')?.error} errorMsg={formError.find(e => e.key === 'name')?.msg}>
                      <AInput testId='knowledge-form-name-input' placeholder={t('knowledgeFormPage.pleaseEnterTheName')} maxLength={50} value={name} onChange={e => {
                        setName(e.target.value)
                      }} />
                    </FormItem>
                    <FormItem label={t('knowledgeFormPage.email')} required
                      error={formError.find(e => e.key === 'email')?.error} errorMsg={formError.find(e => e.key === 'email')?.msg}>
                      <AInput testId='knowledge-form-email-input' placeholder={t('knowledgeFormPage.pleaseEnterTheEmail')} maxLength={100} value={email} onChange={e => {
                        setEmail(e.target.value)
                      }} />
                    </FormItem>
                  </FormRow>
                  <FormRow>
                    <FormItem label={t('knowledgeFormPage.companyName')} required
                      error={formError.find(e => e.key === 'companyName')?.error} errorMsg={formError.find(e => e.key === 'companyName')?.msg}>
                      <AInput testId='knowledge-form-company-input' placeholder={t('knowledgeFormPage.pleaseEnterTheCompanyName')} maxLength={100} onChange={(e) => {
                        setCompanyName(e.target.value)
                      }} />
                    </FormItem>
                    <FormItem required label={t('knowledgeFormPage.department')} error={formError.find(e => e.key === 'department')?.error} errorMsg={formError.find(e => e.key === 'department')?.msg}>
                      <DropdownSelector testId='knowledge-form-department-selector' options={DEPARTMENT_OPTIONS} otherPlaceholder={t('knowledgeFormPage.pleaseEnter')} placeholder={t('knowledgeFormPage.pleaseSelectTheDepartment')}
                        onChange={opt => {
                          setDepartment(opt)
                        }}
                      />
                    </FormItem>
                  </FormRow>
                  <FormRow>
                    <FormItem required label={t('knowledgeFormPage.role')} error={formError.find(e => e.key === 'role')?.error} errorMsg={formError.find(e => e.key === 'role')?.msg}>
                      <DropdownSelector testId='knowledge-form-role-selector' options={ROLE_OPTIONS} otherPlaceholder={t('knowledgeFormPage.pleaseEnter')} placeholder={t('knowledgeFormPage.pleaseSelectTheRole')} onChange={opt => {
                        setRole(opt)
                      }}
                      />
                    </FormItem>
                    {
                      isInternal
                        ? <FormItem required label={t('knowledgeFormPage.province')} error={formError.find(e => e.key === 'province')?.error} errorMsg={formError.find(e => e.key === 'province')?.msg}>
                          <ASelect testId='knowledge-form-province-select' options={PROVINCE_OPTIONS} placeholder={t('knowledgeFormPage.pleaseSelectTheProvince')}
                            onChange={key => {
                              const province = commonUtils.transferProvinceKeyToZhTranslateText(key)
                              setProvince(province)
                            }} />
                        </FormItem>
                        : <FormItem required label={t('knowledgeFormPage.country')} error={formError.find(e => e.key === 'province')?.error} errorMsg={formError.find(e => e.key === 'country')?.msg}>
                          <DropdownSelector testId='knowledge-form-country-selector' options={COUNTRY_OPTIONS} otherPlaceholder={t('knowledgeFormPage.pleaseEnter')} placeholder={t('knowledgeFormPage.pleaseSelectTheCountry')}
                            onChange={opt => {
                              // const country = commonUtils.transferCountryKeyToZhTranslateText(opt.value)
                              setCountry(opt)
                            }} />
                        </FormItem>
                    }
                  </FormRow>
                </div>
                <div className={styles.btnBox}>
                  <AButton testId='knowledge-form-submit-btn' type='primary' size='LG' onClick={handleSubmit}>
                    <span>{t('knowledgeFormPage.submit')}</span>
                    <AIcon type='icon-line-global_arrow'></AIcon>
                  </AButton>
                </div>
              </>
            }
            {
              mode === 'download' && <>
                <p className={styles.title}>{t('knowledgeFormPage.title2')}</p>
                <div className={styles.downloadBox}>
                  {
                    resource.map((item) => (
                      <div className={styles.downloadItem} key={item.url}>
                        <div className={styles.downloadItemImageBox}>
                          <img className={styles.downloadItemImage} src={commonUtils.getImagePath('knowledgeForm/file-icon.png')} alt="" />
                        </div>
                        <div className={styles.downloadItemContent}>
                          <div className={styles.downloadItemTitleBox}>
                            <p className={styles.downloadItemTitle}>{item.title}</p>
                          </div>
                          <div className={styles.downloadBtnBox}>
                            <div className={styles.downloadBtn} onClick={() => handleDownload(item)}>
                              <AIcon type={'icon-line-global_download'} width={16} style={{ color: '#8463F9' }} />
                              <span>{t('knowledgeFormPage.download')}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </>
            }
          </div>
          <div className={styles.bg}></div>
        </div>
      </div>
    </div>
  )
}

export default KnowledgeFormPage;
